import React, { useState, useMemo } from 'react';
import { Pressable, StyleSheet, Platform, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import useResponsiveness from '@/hooks/useResponsiveness';

const createStyles = (colors) => StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: 'transparent',
    borderRadius: 17,
    height: 34,
    flexShrink: 0,
    minWidth: 34,
    paddingHorizontal: 8,
    ...Platform.select({
      web: {
        transition: 'all 0.2s ease',
        cursor: 'pointer',
      }
    })
  },
  buttonHovered: {
    backgroundColor: colors.solid_color_tertiary,
  },
  inner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  buttonDot: {
    position: 'absolute',
    top: 3,
    right: 3,
    width: 10,
    height: 10,
    borderRadius: 10,
    backgroundColor: 'rgb(255, 40, 40)',
    borderWidth: 2,
    borderColor: colors.solid_color_primary,
  },
});

const ChatInputMobileMenuButton = React.forwardRef(function ChatInputMobileMenuButton({ onPress, isMissingRequiredParameters, disabled = false, ...props }, ref) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();
  const styles = useMemo(() => createStyles(colors), [colors]);
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable
      {...props}
      ref={ref}
      disabled={disabled}
      accessibilityRole="button"
      accessibilityLabel="Parameters"
      accessibilityState={{ disabled }}
      hitSlop={{ top: 5, bottom: 5, left: 5, right: 5 }}
      style={[styles.button, isHovered && styles.buttonHovered]}
      onPress={onPress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <View style={styles.inner}>
        <Icon name="sliders-simple" size={14} color={colors.text_color_primary} />
        {!isXS && <Text size="s" color="primary" numberOfLines={1}>Parameters</Text>}
      </View>
      {isMissingRequiredParameters ? <View style={styles.buttonDot} /> : null}
    </Pressable>
  );
});

export default ChatInputMobileMenuButton;

